// extracted by mini-css-extract-plugin
export default {"auto-complete-input":"style_auto-complete-input__UY1js"};